import adminHttp from "@/api/adminHttp";

const END_POINT = "/api/admin/prediction"

export default {
    store: (watchId, params) => adminHttp.post(`/api/admin/watch/${watchId}/prediction`, params),
    show: (predictionId) => adminHttp.get(`${END_POINT}/${predictionId}`),
    update: (predictionId, params) => adminHttp.put(`${END_POINT}/${predictionId}`, params),
    publish: (predictionId) => adminHttp.post(`${END_POINT}/${predictionId}/publish`),
    close: (predictionId) => adminHttp.post(`${END_POINT}/${predictionId}/close`),
    resolve: (predictionId, params) => adminHttp.post(`${END_POINT}/${predictionId}/resolve`, params),
    getTeams: (predictionId) => adminHttp.get(`${END_POINT}/${predictionId}/teams`),
    getVoters: (predictionId, teamId) => adminHttp.get(`${END_POINT}/${predictionId}/teams/${teamId}/voters`),
}